import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import {
  button,
  callBtnContainer,
  callBtnIcon,
  ctaButtonText,
  desktopCta,
  fullHeightBtn,
  orangeBtn,
} from './CallToUsButton.module.css'

const CallToUsButton = ({
  cta,
  desktop,
  fullHeight,
  mobile,
  onClick,
  orange,
}) => {
  if (onClick) {
    return (
      <button
        className={`${button} ${callBtnContainer} ${
          fullHeight ? fullHeightBtn : ''
        } ${orange ? orangeBtn : ''} ${desktop ? desktopCta : ''}`}
        onClick={onClick}
        type="button"
      >
        {!orange && !mobile && (
          <StaticImage
            alt="Call Button"
            className={callBtnIcon}
            formats={['auto', 'webp']}
            loading="eager"
            placeholder="none"
            quality="50"
            src="../../assets/icons/Shape.png"
          />
        )}
        <span className={ctaButtonText}>{cta.title}</span>
      </button>
    )
  }
  return (
    <a
      className={`${callBtnContainer} ${fullHeight ? fullHeightBtn : ''} ${
        orange ? orangeBtn : ''
      } ${desktop ? desktopCta : ''}`}
      href={orange ? cta.url : `tel:${cta.target}`}
    >
      {!orange && !mobile && (
        <StaticImage
          alt="Call Button"
          className={callBtnIcon}
          formats={['auto', 'webp']}
          loading="eager"
          placeholder="none"
          quality="50"
          src="../../assets/icons/Shape.png"
        />
      )}
      <span className={ctaButtonText}>{cta.title}</span>
    </a>
  )
}

export default CallToUsButton
